import { render, staticRenderFns } from "./numeric.vue?vue&type=template&id=0bf1d9bd&scoped=true&"
import script from "./numeric.vue?vue&type=script&lang=js&"
export * from "./numeric.vue?vue&type=script&lang=js&"
import style0 from "./numeric.vue?vue&type=style&index=0&id=0bf1d9bd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1d9bd",
  null
  
)

export default component.exports